import { createApp } from 'vue';
import App from './App.vue';
import router from "./router";
import AOS from 'aos';
import 'aos/dist/aos.css';
import i18n from './i18n';
import store from "./state/store";

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import BootstrapVueNext, { BModal } from 'bootstrap-vue-next';
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import { vMaska } from "maska"

import VueFeather from 'vue-feather';
import noAutofill from '@/directives/noAutofill';

import '@/assets/scss/config/minimal/app.scss';

// App-weit: Modals schliessen nur über X/Abbrechen/Esc, nicht per Klick daneben (bootstrap-vue-next 0.15 kennt keine globalen Defaults).
if (BModal?.props?.noCloseOnBackdrop) BModal.props.noCloseOnBackdrop.default = true;
import '@/assets/scss/mermaid.min.css';
import 'bootstrap/dist/js/bootstrap.bundle'

function getSystemThemeMode() {
    if (typeof window === 'undefined') return 'light';
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light';
}

function getThemePreference() {
    try {
        const preference = localStorage.getItem('theme-preference');
        if (preference === 'dark' || preference === 'light' || preference === 'system') {
            return preference;
        }
    } catch (_) {
        // Ignore storage access errors.
    }
    return 'system';
}

function resolveInitialThemeMode() {
    if (typeof window === 'undefined') return 'light';

    const themePreference = getThemePreference();

    try {
        if (!localStorage.getItem('theme-preference')) {
            localStorage.setItem('theme-preference', 'system');
        }
    } catch (_) {
        // Ignore storage access errors.
    }

    if (themePreference === 'dark' || themePreference === 'light') {
        return themePreference;
    }

    if (themePreference === 'system') {
        return getSystemThemeMode();
    }

    let storedLayoutMode = null;
    try {
        storedLayoutMode = localStorage.getItem('layout-mode');
    } catch (_) {
        // Ignore storage access errors.
    }

    if (storedLayoutMode === 'dark' || storedLayoutMode === 'light') {
        return storedLayoutMode;
    }

    return getSystemThemeMode();
}

function shouldFollowSystemTheme() {
    const preference = getThemePreference();
    return preference === 'system';
}

function setupSystemThemeListener() {
    if (typeof window === 'undefined' || !window.matchMedia) return;

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const onSystemThemeChange = () => {
        if (!shouldFollowSystemTheme()) return;
        store.dispatch('layout/changeMode', { mode: getSystemThemeMode() });
    };

    if (mediaQuery.addEventListener) {
        mediaQuery.addEventListener('change', onSystemThemeChange);
        return;
    }

    if (mediaQuery.addListener) {
        mediaQuery.addListener(onSystemThemeChange);
    }
}

// FakeBackend authentication
// import { configureFakeBackend } from './helpers/fake-backend';
// configureFakeBackend();


// Firebase authentication
// import { initFirebaseBackend } from './authUtils';

// const firebaseConfig = {
//     apiKey: process.env.VUE_APP_APIKEY,
//     authDomain: process.env.VUE_APP_AUTHDOMAIN,
//     databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
//     projectId: process.env.VUE_APP_PROJECTId,
//     storageBucket: process.env.VUE_APP_STORAGEBUCKET,
//     messagingSenderId: process.env.VUE_APP_MEASUREMENTID
// };

// initFirebaseBackend(firebaseConfig);



AOS.init({
    easing: 'ease-out-back',
    duration: 1000
});

store.dispatch('layout/changeMode', { mode: resolveInitialThemeMode() });
setupSystemThemeListener();

createApp(App)
    .use(store)
    .use(router)
    .use(VueApexCharts)
    .use(BootstrapVueNext)
    .component(VueFeather.type, VueFeather)
    .directive("maska", vMaska)
    .directive("no-autofill", noAutofill)
    .use(i18n)
    .use(VueSweetalert2)
    .use(vClickOutside).mount('#app');